import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getNomoi($where: String, $offset: Int, $limit: Int, $order: String) {
    getNomoi(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: name
        description: name
      }
      recordCount
    }
  }
`;

export function useGetNomoiAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, {
    fetchPolicy: 'cache-first',
  });
}

function useGetRegionLazyQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-and-network' });
  //return [null, { loading: null, data: null }];
}

// interface LcFsProps extends FsProps {
//   size?: 'sm' | 'lg';
// }

export const FieldSelectNomos = ({
  label = 'Νομός',
  name = 'addressNomos',
  defaultValues = {},
  // size = 'sm',
  ...rest
}: FsProps) => {
  //const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      // height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={label}
      name={name}
      sbLabel={(defaultValues as any)?.addressNomos ?? undefined}
      //where={where}
      hook={useGetRegionLazyQuery}
    />
  );
};

